import React from "react";

const DocumentsIcon = (props) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M17.8235 1C19.5778 1 21 2.34315 21 4L21 20C21 21.6569 19.5778 23 17.8235 23H6.17647C4.42215 23 3 21.6569 3 20V4C3 2.34315 4.42216 1 6.17647 1H17.8235ZM6 5H18V7H6V5ZM15 9H6V11H15V9ZM6 13H18V15H6V13ZM15 17H6V19H15V17Z"
				fill="#EFF0F6"
			/>
		</svg>
	);
};

export default DocumentsIcon;
